import { baseUploadURL } from './axios';

// Small ar/en dictionary for the shared SweetAlert dialogs (titles/buttons).
const SWAL_AR: Record<string, string> = {
  Error: 'خطأ',
  Success: 'تم بنجاح',
  Yes: 'نعم',
  No: 'لا',
};
const txt = (k: string): string =>
  (localStorage.lang || 'ar') === 'ar' ? SWAL_AR[k] || k : k;

export const HelperMethods = (v: any) => {
  v.$error = (e: any, error: any, timer: any = 1500) => {
    let message;
    // let messageType = error.response.data.message
   


    if (typeof error === 'string') {
      message = error;
      
    } else {
      
      message = error.response.data
      
    }

    if (typeof message === 'string') {
      e.fire({
        icon: "error",
        title: txt('Error'),
        text: message,
        showConfirmButton: false,
        timer,
      });
    }
    if (typeof message === 'object') {
      e.fire({
        icon: "error",
        title: txt('Error'),
        text: message,
        showConfirmButton: false,
        timer,
      });
    } else {

      const listMesssage: any[] = [];
      message.forEach((el: any) => {
        if (el.constraints) {
          const key = Object.keys(el.constraints);
          listMesssage.push(el.constraints[key[0]]);
        } else {
          listMesssage.push(error.response.data.message[0]);
        }
      });

      e.fire({
        icon: "error",
        title: listMesssage,
        text: listMesssage,
        showConfirmButton: false,
        timer,
      });
    }
  };

  v.$errorMsg = (e: any, error: any, timer: any = 1500) => {
    e({
      icon: 'error',
      title: txt('Error'),
      text: error,
      showConfirmButton: false,
      timer,
    });
  };

  v.$success = (e: any, message: any, timer: any = 1500) => {
    e.fire({
      icon: 'success',
      title: txt('Success'),
      text: message,
      showConfirmButton: false,
      timer,
    });
  };

  v.$changeRtl = (lang: any) => {
    localStorage.lang = lang;
    const d: any = document.getElementById('body');
    const isAr = lang === 'ar';
    // Keep <html> in sync: dir/lang drive native RTL layout, form controls,
    // scrollbars and logical CSS (margin-inline-*), not just the .rtl class.
    document.documentElement.setAttribute('dir', isAr ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', isAr ? 'ar' : 'en');
    if (d) {
      d.classList.toggle('rtl', isAr);
    }
  };

  {
    // default locale is Arabic: apply dir/lang/.rtl even before a choice is stored
    v.$changeRtl(localStorage.lang || 'ar');
  }

  v.$file2base64 = (
    ev: any,
    cb: (arg0: string | ArrayBuffer | null) => void,
  ) => {
    const file = ev.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent) => {
      const content = (e.target as FileReader).result;
      cb(content);
    };
    reader.readAsDataURL(file);
  };

  v.$verify = (e: any, message: any, cb: any, timer: any = 1000) => {
    e.fire({
      title: message.question,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: txt('Yes'),
      cancelButtonText: txt('No'),
    }).then((result: any) => {
      if (result.value) {
        e.fire({
          icon: 'success',
          title: txt('Success'),
          text: message.confirmation,
          showConfirmButton: false,
          timer,
        });
      }
      cb(result);
    });
  };

  v.$searchData = (data: any) => {
    // tslint:disable-next-line: prefer-const
    let newData: any = {};
    for (const key in data) {
      if (data[key] != null && data[key] !== '') {
        newData[key] = data[key];
      }
    }
    return newData;
  };

  v.$baseUploadURL = baseUploadURL;

  v.$print = () => {
    window.print();
  };

  v.$getByLang = function(val: any) {
    return val[this.$i18n.locale];
  };

  v.$errorHandler = (event: any) => {
    event.target.src =
      'https://mpng.subpng.com/20190501/eil/kisspng-user-profile-computer-icons-image-default-daniela-klasn-martin-societe-generale-securiti-5cca4fa5b997b2.1263112315567625337602.jpg';
  };
};
